<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data().header" [separator]="false" />
  </ng-container>

  <ng-container body>
    <email-margin [height]="10" />
    <email-text [contents]="data().p1_html" />
    <email-margin [height]="20" />
    <email-text [contents]="data().p2_html" />
    <email-margin [height]="18" />
    <email-button [href]="data().button_link" [label]="data().button_text" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
